import API from "./api";

const StudentBatchService = {
  // Get student's batch info for a course
  getStudentBatchForCourse: async (courseId) => {
    try {
      const response = await API.get(`/student-batch/course/${courseId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get batch materials with pagination and search
  getBatchMaterials: async (
    batchId,
    parentId = null,
    page = 1,
    limit = 10,
    search = "",
  ) => {
    try {
      let url = `/student-batch/materials/${batchId}?page=${page}&limit=${limit}`;
      if (parentId) {
        url += `&parent_id=${parentId}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get enabled course materials for a batch with pagination and search
  getEnabledCourseMaterials: async (
    batchId,
    parentId = null,
    page = 1,
    limit = 10,
    search = "",
  ) => {
    try {
      let url = `/student-batch/course-materials/${batchId}?page=${page}&limit=${limit}`;
      if (parentId) {
        url += `&parent_id=${parentId}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder path for course materials
  getCourseFolderPath: async (materialId, batchId) => {
    try {
      const response = await API.get(
        `/student-batch/folder-path/course/${materialId}?batch_id=${batchId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get batch folder item count
  getBatchFolderCount: async (folderId) => {
    try {
      const response = await API.get(
        `/student-batch/folder-count/batch/${folderId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error getting batch folder count:", error);
      return { data: { count: 0 } };
    }
  },

  // Get course folder item count
  getCourseFolderCount: async (folderId, batchId = null) => {
    try {
      let url = `/student-batch/folder-count/course/${folderId}`;
      if (batchId) {
        url += `?batch_id=${batchId}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      console.error("Error getting course folder count:", error);
      return { data: { count: 0 } };
    }
  },

  // Get course materials for online student (full access, no batch) with pagination and search
  getOnlineCourseMaterials: async (
    courseId,
    parentId = null,
    page = 1,
    limit = 10,
    search = "",
  ) => {
    try {
      let url = `/courses/${courseId}/student-materials?page=${page}&limit=${limit}`;
      if (parentId) {
        url += `&parent_id=${parentId}`;
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get folder path for online student
  getOnlineFolderPath: async (materialId, courseId) => {
    try {
      const response = await API.get(
        `/courses/${courseId}/folder-path/${materialId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Mark video as watched
  markVideoWatched: async (materialId, batchId, watchedPercentage = 100) => {
    try {
      const response = await API.post("/student-batch/progress/video-watched", {
        material_id: materialId,
        batch_id: batchId,
        watched_percentage: watchedPercentage,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get student progress for a batch
  getStudentProgress: async (batchId) => {
    try {
      const response = await API.get(`/student-batch/progress/${batchId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default StudentBatchService;
